import { useMutation } from '@tanstack/react-query';
import { backendServices } from '../../services';
import { DocumentViewModel } from '../../services/backendServices/ViewModels';

export function usePutDocument() {
    const mutation = useMutation({
        mutationFn: async ({ id, body }: { id: number; body: DocumentViewModel }) => {
            const api = new backendServices.Apis.DocumentApi();
            const res = await api.putDocument(id, body);
            return res.data;
        },
    });

    return mutation;
}
